export default "__VITE_ASSET__Al7NUzJP__"